import { Skeleton } from "@mui/material";

export const ContractDetailsSkeleton = () => {
    return (
        <>
            <Skeleton
                animation="wave"
                variant="rectangular"
                width="20%"
                height={60}
                sx={{ mb: 1 }}
            />
            <Skeleton
                animation="wave"
                variant="rectangular"
                width="100%"
                height="50vh"
            />
        </>
    );
};
